import React from "react";
import Button from "../../../Button/Button";
import Style from "../OrderListAll/OrderListAll.module.scss";
import ProductInfoAllPeyk from "./ProductInfoAllPeyk/ProductInfoAllPeyk";

const OrderListAllPeyk = ({ item, handleOk}) => {
    console.log(item)
  return (
    <div className={Style.supplier}>
      {item &&
        item.map((val, index) => {
          return (
            <div key={index}>
              <div key={index}>
                <ProductInfoAllPeyk data={val} />
              </div>
            </div>
          );
        })}
      <div className={Style.btnHolder}>
        <Button
          ClassBtn={"okBtn"}
          Value={"تایید"}
          ClickHandler={handleOk}
        ></Button>
      </div>
    </div>
  );
};

export default OrderListAllPeyk;
